import { useState, useEffect } from "react";
import Modal from "../modal";
import Cookies from "universal-cookie";
import { getPantallaActivos, ValidarPantalla } from "../../services/public/screen";
import Toasts from "../toast";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";

function VincularPantalla({ show, handleshow, handleparams }) {
    const [codigovinc, setCodigoVinc] = useState("");
    const [pantalla, setPantalla] = useState([]);
    const [pantallaId, setPantallaId] = useState(0);
    const [showToast, setShowToast] = useState(false);
    const [opciones, setOpciones] = useState([]);
    const [habilita, setHabilita] = useState(false);
    const [valida, setValida] = useState(false);
    const navigate = useNavigate();
  
  //-----
  const handleAceptar = async() => 
    {
      setHabilita(true);
      setShowToast(false);
      setValida(false);
      const response = await ValidarPantalla(pantallaId,codigovinc);
      if (response) 
        {
          if (response.status === 200) 
            {
              const cookies = new Cookies();
              cookies.set('ApkpI',response.data.data[0].ClientAPKey, { path: "/",maxAge: 1000000 });
              cookies.set('ApkpV',response.data.data[0].CodigoVinc, { path: "/",maxAge: 1000000 });
              cookies.set('Ctrpar',response.data.data[0].AreaId, { path: "/",maxAge: 1000000 });
              cookies.set('CtrpId',response.data.data[0].PantallaId, { path: "/",maxAge: 1000000 });
              cookies.set('Ctrnpant',response.data.data[0].NombrePant, { path: "/",maxAge: 1000000 });
              cookies.set('Ctrprj',response.data.data[0].Proyecta, { path: "/",maxAge: 1000000 });
              cookies.set('CtrLvz',response.data.data[0].llamVoz, { path: "/",maxAge: 1000000 });
           
              handleshow(false);  
              handleparams();
            }
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
            setValida(true);
          }
        }
        setHabilita(false);
    };
   
    //-------
    const handleCancel = async () => 
      {
         handleshow(false);
         navigate('/');
      };
    
    //------- 
    const handleDispensa = async()=>
      {
         const response = await getPantallaActivos();
         if (response) 
          {
            if (response.status === 200) 
              {
                 setPantalla(response.data.data || []);    
              }
            else 
              {
                const Mensaje = response.message;
                const opc = { type: "Danger", message: Mensaje, active: true };
                setOpciones(opc);
                setShowToast(true);
              }
          }  
      }
    //--------
    useEffect(() => 
      {
         if (show) 
          {
             handleDispensa()
           }
      }, [show]);
 
  return (
    <>
      <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Vincular Pantalla'}>
          <div className="flex lg:w-[24rem]">
              <form noValidate className="w-full">
                 <div className="w-full">
                     <label>Pantalla</label>
                     <select id="dispensador" name="dispensador" className="" value={pantallaId || 0} onChange={(e) => setPantallaId(Number(e.target.value))} label="Dispensador">
                        <option value={0} disabled>
                            Seleccionar una Pantalla...
                        </option>
                        {pantalla.map((item) => {
                         return (
                             <option key={item.PantallaId} value={item.PantallaId}>
                                {item.NombrePant} ( Area &#10148; {item.NombreArea})
                             </option>
                           );
                        })}
                     </select>
                 </div>
                 <div className="mt-4">
                    <label>Código de Vinculación</label>
                    <input type="text" value={codigovinc} placeholder="Código de 8 caracteres" autoComplete="off" onChange={(e) => setCodigoVinc(e.target.value)}></input>
               <div className="flex w-full gap-4 mt-6 justify-end">
                 <button name="Aceptar" className="btnprimary" onClick={handleAceptar} disabled={habilita} type="button">Aceptar</button>
                 <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
               </div>
            </div>
              </form>
           </div>
      </Modal>            
{showToast && (
    <Toasts type={opciones.type} message={opciones.message} active={opciones.active}>
      
    </Toasts>
             )}
    
    </>
  );
}
VincularPantalla.propTypes = {
  show: PropTypes.bool.isRequired,
  handleshow: PropTypes.func.isRequired,
  handleparams: PropTypes.func.isRequired,
};

export default VincularPantalla;
